import React, { Component } from 'react';
import {
  Button,
  Form,
  Radio,
} from 'semantic-ui-react';

class RemoteSigning extends Component {
  render() {
    const {
      code,
      email,
      remote,
    } = this.props;

    return (
      <div style={{
        padding: '25px 0',
        borderTop: '1px solid #eee',
        borderBottom: '1px solid #eee',
      }}>
        <h2>Remote Signing</h2>
        <p>
          Enabling remote signing allows a link to this contract to be sent to the renter's email address for signing.
        </p>
        <Form size="large">
          <Form.Field
            label={`Remote Signing ${remote ? 'Enabled' : 'Disabled'}`}
            name="remote_sign"
            control={Radio}
            checked={remote}
            onChange={(e, d) => this.props.onChange(d.checked)}
            // onChange={this.onRemoteChange}
            // disabled={email ? false : true}
            toggle
          />
          {
            remote &&
              <React.Fragment>
                <Form.Input
                  label="Recipient Email Address (read-only)"
                  width={6}
                  name="email"
                  required
                  value={email ? email : ''}
                  readOnly
                />
                <Button
                  positive
                  content={code ? 'Resend Contract' : 'Send Contract'}
                  size="huge"
                  fluid
                  icon="mail"
                  labelPosition="right"
                  style={{ marginTop: '30px' }}
                  onClick={this.props.onSubmit}
                  disabled={!email ? true : false}
                />
              </React.Fragment>
          }
        </Form>
      </div>
    );
  }
}

export default RemoteSigning;

